var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile === 'SUMUT')?_c('f-login-sumut'):(_vm.profile === 'BENGKULU')?_c('f-login-bengkulu'):(_vm.profile === 'SULTENG')?_c('f-login-sulteng'):(_vm.profile === 'SULUT')?_c('f-login-sulut'):_c('f-login-default')
}
var staticRenderFns = []

export { render, staticRenderFns }